import React, { Component } from "react";
import "./MessageBox.css";
import Modal from "react-bootstrap/es/Modal";
import {FormattedMessage} from "react-intl";

class MessageBox extends Component {
    constructor(props){
        super(props);
        this.state = {
            show : false,
            heading: this.props.heading,
            message : this.props.message
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
    }

    handleClose = () => {
        this.setState({
            show : false
        })
    };

    handleShow = () => {
        this.setState({
            show : true
        })
    };

    render(){

        // console.log("MSG BOX SHOW ====> ", this.props.show);
        return(
            <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <div className="title-1 color-text">
                        {this.state.heading}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="color-text">
                        <div className="row">
                            <div className="col-md-8 data-label">

                                {this.state.message}

                            </div>


                        </div>
                        <div className="form-row-spacer"></div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12">

                        <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleClose}>
                            <FormattedMessage id="app.common.msg-box.close"
                                              defaultMessage="Close"
                                              description=""/>
                        </button>

                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

}

export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/Common/MessageBox/MessageBox.js